(function () {
  'use strict';

  angular
    .module('app.translate')
    .run(translateRun);
  translateRun.$inject = ['$rootScope', '$translate'];

  function translateRun($rootScope, $translate) {
    // Internationalization
    // ----------------------

    $rootScope.language = {
      // Handles language dropdown
      listIsOpen: false,
      // list of available languages
      available: {
        'en': 'English',
        'lt': 'Lietuvių'
      },
      // display always the current ui language
      init: function () {
        var proposedLanguage = $translate.proposedLanguage() || $translate.use();
        var preferredLanguage = $translate.preferredLanguage(); // we know we have set a preferred one in app.config
        var localeId = (proposedLanguage || preferredLanguage);
        $rootScope.language.selected = $rootScope.language.available[localeId];
        $rootScope.language.selectedLocale = localeId;
        moment.locale(localeId);
      },
      set: function (localeId) {
        // Set the new idiom
        $translate.use(localeId);
        // save a reference for the current language
        $rootScope.language.selected = $rootScope.language.available[localeId];
        // save a reference for the curent locale
        $rootScope.language.selectedLocale = localeId;
        // finally toggle dropdown
        $rootScope.language.listIsOpen = !$rootScope.language.listIsOpen;
        // set moment locale
        moment.locale(localeId);
      }
    };

    $rootScope.language.init();
  }
})();
